// Copyright (c) Move Closer 2022.

import { Variant } from '../../../../dsl/atoms/Button'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const ARTICLE_CARD_COMPONENT_KEY = 'ArticleCardComponent'

export interface ArticleCardConfig {
  buttonVariant: Variant
  showDate: boolean
  useSingleLink: boolean
  headingLevel: number
  maxLines: {
    default: number
    horizontal: number
  }
}

export const ARTICLE_CARD_DEFAULT_CONFIG: ArticleCardConfig = {
  buttonVariant: Variant.Outline,
  showDate: true,
  useSingleLink: false,
  headingLevel: 6,
  maxLines: {
    default: 3,
    horizontal: 3
  }
}
